import React from 'react'

import { BottomSheetNavbar } from 'partials/BottomSheetNavbar'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Text } from 'widgets/Text'

import commonStyles from 'utils/styles/commonStyles'

import { useInfoModal } from 'contexts/InfoModalContext'

import ClipboardImage from 'assets/images/clipboard.png'

export const InfoPage = ({ ...rest }) => {
  const { title, infoText } = rest?.data

  const infoModalRef = useInfoModal()

  const handleClose = () => {
    infoModalRef?.current?.dismiss()
  }

  return (
    <Box flex={1} backgroundColor='white' align='center'>
      <BottomSheetNavbar title={title} onClose={handleClose} />
      <Box height={130} width={130} padding={{ top: 'md' }}>
        <Image resizeMode='contain' source={ClipboardImage} style={commonStyles.fullSize} />
      </Box>
      <Box flex={1} flexDirection='row' padding={{ top: 'xl', horizontal: 'lg' }}>
        <Text align='center' color='black' fontSize='sm'>
          {infoText}
        </Text>
      </Box>
    </Box>
  )
}
